import BaseModelAPI from '../BaseModelAPI';

export default class MobileDevice extends BaseModelAPI {
    static entity = 'mobiledevice';
    static entityName = 'mobiledevice';

    constructor() {
        super();

        /*APP_MODEL_DEFINITION*/
        this.id = '';
        this.name = '';
        this.identifierCode = '';
        this.boundToPrinterId = '';
        this.boundToPrinter = {};
        this.isFromUpload = false;
        this.isSavedToBackend = true;
        this.uploadValidationMessage = '';
        this.uploadValidationStatus = '';
        /*END_APP_MODEL_DEFINITION*/
    }

    static async getMyDevice(this_) {
        return this_.$http.get(`${this.entityName}/current/mydevice`)
            .then(response => {
                let responseData = response.data;
                return responseData;
            })
            .catch(function(error){
                this_.$store.dispatch('addErrorMessageGlobal', error);
                throw error;
            });
    }

    static async testPrint(this_) {
        return this_.$http.get(`${this.entityName}/current/testprint`)
            .then(response => {
                let responseData = response.data;
                return responseData;
            })
            .catch(function(error){
                this_.$store.dispatch('addErrorMessageGlobal', error);
                throw error;
            });
    }
}